<template>
    <div>
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" class="form_box">
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
              <a-input  :rows="4" v-model="form.name"  :maxLength=200
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }" type="textarea" />
<!--                <a-textarea />-->

            </a-form-model-item>
<!--          {{this.$store.state.urlChang}}-->
          
            <a-form-model-item
                    ref="content"
                    label="内容"
                    prop="content"
                    :help="formErr.content"
                    :validateStatus='!formErr.content||formErr.content==""?"":"error"'
            >
<!--            <ckeditor4 :value="contenta" v-on:input="ckeditorContent"></ckeditor4>-->
                <a-input v-model="form.content"  type="hidden" />
                <div style="position: relative"><ckeditor4 ref="ckeditor" :value="contenta" v-on:input="ckeditorContent"  @changCkNum=" (type,data)=>{   cknum=type  } " @instanceReadyCk="instanceReadyCk"></ckeditor4>
<!--                    <span style=" position: absolute!important;bottom: -5px;right: 20px">{{cknum}}/10000</span>--></div>
            </a-form-model-item>
            <a-form-model-item
                    ref="release_time"
                    label="发布时间"
                    prop="release_time"
                    :help="formErr.release_time"
                    :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'
            >
                <a-date-picker show-time   :format="dateFormat" :defaultValue="deforDate"  v-model="form.release_time"  />

            </a-form-model-item>
            <a-form-model-item
                    ref="versions"
                    label="版本"
                    prop="versions"
                    :help="formErr.versions"
                    :validateStatus='!formErr.versions||formErr.versions==""?"":"error"'
            >
                <a-checkbox-group v-model="form.versions" :value="form.versions"  >
                <span v-for="(item,index) in this.seleList.version" style="display: inline-block;margin-right: 8px" >
                 <a-checkbox :value="item.id"> </a-checkbox>
                <span style="max-width: 200px;overflow: hidden;display: inline-block;height:20px;position: relative;top: 2px;padding-left: 5px; " class="sef1" :title="item.name">{{item.name}}</span>
                </span>
                </a-checkbox-group>

            </a-form-model-item>

            <a-form-model-item
                    ref="site_types"
                    label="网站类型"
                    prop="site_types"
                    :help="formErr.site_types"
                    :validateStatus='!formErr.site_types||formErr.site_types==""?"":"error"'
            >
                <a-checkbox-group v-model="form.site_types" :value="form.site_types">
                <span v-for="(item,index) in this.seleList.site_type" style="display: inline-block;margin-right: 8px">
                <a-checkbox :value="item.value"> </a-checkbox>
                <span style="max-width: 200px;overflow: hidden;display: inline-block;height:20px;position: relative;top: 2px;padding-left: 5px; " class="sef1" :title="item.name">{{item.name}}</span>
                </span>
                </a-checkbox-group>

            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="item in this.seleList.status"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>

            <!-- <a-form-model-item
                    ref="is_popup"
                    label="显示"
                    prop="is_popup"
                    :extra="formErr.is_popup"
                    :validateStatus='!formErr.is_popup||formErr.is_popup==""?"":"error"'
            >
                <a-switch   defaultChecked v-model="form.is_popup" />
                <span style="padding-left: 5px">客户后台是否弹窗显示</span>
            </a-form-model-item> -->
            

            <a-form-model-item
                    ref="popup_type"
                    label="提醒样式"
                    prop="popup_type"
                    :extra="formErr.popup_type"
                    :validateStatus='!formErr.popup_type||formErr.popup_type==""?"":"error"'
            >
                <a-radio-group v-model="form.popup_type">
                    <a-radio :value="item.value" v-for="item in this.seleList.popup_type"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item
                ref="a_information_position_id"
                label="关联分步提醒"
                prop="a_information_position_id"
                :extra="formErr.a_information_position_id"
                v-if="form.popup_type == 1"
            >
                <a-select v-model="form.a_information_position_id" class="seachs" allowClear>
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in this.seleList.position_list ">
                        {{item.title}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item
                v-if="form.popup_type == 2"
              ref="thumb"
              label="缩略图"
              prop="thumb"
              :help="formErr.thumb"
              :validateStatus='!formErr.thumb||formErr.thumb==""?"":"error"'
            >
                <a-upload
                    :action="this.$store.state.urlChang"
                    :data="{type:1}"
                    :file-list="fileList"
                    :headers="headers"
                    @change="(file)=>{handleChange(file)}"
                    :before-upload="beforeUpload"
                    @preview="handlePreview"
                    list-type="picture-card"
                    name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>
            <a-form-model-item
            v-if="form.popup_type == 2 "
                ref="abstract"
                label="弹窗内容"
                prop="abstract"
                :help="formErr.abstract"
                :validateStatus='!formErr.abstract||formErr.abstract==""?"":"error"'>
                <a-input  :rows="4" v-model="form.abstract"  :maxLength=2000
                        @change="(e) => { formErr.abstract=''}"
                        @blur="(e) => {  form.abstract = e.target.value.trim() }" type="textarea" />
<!--            <a-textarea  :rows="4" v-model="form.abstract"  :maxLength=2000-->
<!--                         @change="(e) => { formErr.abstract=''}"-->
<!--                         @blur="(e) => {  form.abstract = e.target.value.trim() }"/>-->

          </a-form-model-item>


          <a-form-model-item>
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            取消
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>
   </div>
</template>

<script>
    import {submitForm, drawerConfig, validator, beforeUpload} from "../../../utils/utils"
    import ckeditor4 from '../../Components/ckeditors'
    import API from "../api";
    import moment from 'moment';
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    let ckData
    export default {
        name: "newForm",
        props: {
            content: {
                type: String,
                default: '请输入您的内容'
            }
        },
        data() {
            return {
                cknum:0,
                id: this.$route.query.id,
                contenta: "",
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                fileList:[],
                seleList:[],
                drawerConfig ,
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                    name:"",
                    abstract:"",
                    content:"",
                    status:1,
                    release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    is_popup:true,
                    site_types:[],
                    versions:[],
                    thumb:"",
                    popup_type:1,
                    a_information_position_id:""
                },
                formErr: {
                    name:"",
                    abstract:"",
                    content:"",
                    status:"",
                    release_time:"",
                    is_popup:"",
                    site_types:"",
                    versions:"",thumb:"",
                    popup_type:"",a_information_position_id:""
                },
                rules: {
                    name: [{required: true, message: "请输入标题 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    abstract: [{required: true, message: "请输入弹框内容",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.abstract)}  , trigger: "blur"  },],
                    content:[{required: true, message: "请输入内容 ",trigger:['change', 'blur']  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.content)}  , trigger:["blur","change"]   },],
                        site_types: [{required: true, message: "请选择网站类型 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.site_types)}  , trigger: "blur"  },],
                    versions:[{required: true, message: "请选择版本 ",trigger:['change', 'blur']  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.versions)}  , trigger:["blur","change"]   },],
                    a_information_position_id: [{required: true, message: "请选择关联分步提醒 ",  }],
                    // ,{max: 10000, message: "内容不能超过10000字符 " ,trigger:['change', 'blur']  }
                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span: 12 },
                },
            };

        },
        components:{ckeditor4},
        created() {
            this.$store.state.adminleftnavnum = "/MessageManagement/MessageManagementList"; //设置左侧导航2-2 active
        },
        mounted(){
            let _that=this
          // console.log("--**--",this.$store.state.urlChang)
            // this.$nextTick().then(function () {
            // if(_that.id!=undefined){ _that.editform(_that.id)}
            // })
            this.getFormData()
        },
        computed: {
            deforDate: function () {
                return moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }
        },
        methods: {
            instanceReadyCk(type){
                if(type==true){
                    let _that=this
                    this.$nextTick().then(function () {
                        if(_that.id!=undefined){
                            _that.editform(_that.id)
                        }
                    })
                }
            },
            ckeditorContent(val) {
                this.form.content = val
                this.formErr.content=""
                this.$refs.ruleForm.validateField('content', (contentError) => {
                    if(!contentError){
                        //当校验通过时，这里面写逻辑代码
                        this.formErr.content=""
                    }
                })
            },
            onClose(){
                this.$router.push({path: '/MessageManagement/MessageManagementList'})
            },
            editform(id){
                API.service.EDIT_DATA(id).then(res => {
                    let data=res.data.data.info
                    data.is_popup==0?data.is_popup=false:data.is_popup=true
                    data.status= data.status
                    data.release_time=moment(res.data.data.info.release_time, 'YYYY-MM-DD HH:mm:ss')
                    this.form = data
                    this.form.versions=data.versions==""?[]:data.versions.split(",").map(Number);
                    this.form.site_types=data.site_types==""?[]:data.site_types.split(",").map(Number);
                    if (this.form.thumb == "") {
                        this.fileList = []
                    } else {
                        this.fileList = [
                            {uid: this.form.thumb,
                                name: this.form.thumb,
                                status: "done",
                                url: this.form.thumb ? this.form.thumb : ""
                            }
                        ]
                    }
                    let _that=this
                    let ckDataa
                    this.$nextTick().then(function (){
                        _that.contenta = data.content_text
                    })
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.contenta = data.content_text
                    //     }, 800)
                    // })
                    // console.log("---------------",this.form.site_types)
                    // this.form.site_types=""?this.form.site_types=[]:this.form.site_types =data.site_types
                    // this.form.versions=""?this.form.versions=[]:this.form.versions =data.versions

                        // versions:[]
                    this.form.id=id
                })
            },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                })
            },
          handleCancel() {
            this.previewVisible = false;
          },
          handleChange(info ) {
            let {fileList} = info;
            const status = info.file.status;

            if (status !== 'uploading') {
              this.fileList=[]
            }
            if (status === 'done') {
              this.formErr.thumb=""
              this.fileList= fileList
            } else if (status === 'error') {
            }
            if (status === 'uploading') {
              this.fileList= fileList
            }
            if (status=== 'done') {
              getBase64(info.file.originFileObj, imageUrl => {
                this.formErr.thumb=""
                this.fileList= fileList
              });
            }
            //重新设置state
            // this.setState( {fileList});
          },
          beforeUpload(file) {
            return  beforeUpload(file)
            // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            // if (!isJpgOrPng) {
            //     this.$message.error('只能上传jpg，png类型图片!');
            //     return false
            // }
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //     this.$message.error('图片必须小于 2MB!');
            //     return false
            // }
            // return new Promise(function (resolve,reject) {
            //     resolve(file)
            // })
          },
          async handlePreview(file) {
            if (!file.url && !file.preview) {
              file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
          },
            onSubmit() {
                let _this = this;
                this.$refs.ckeditor.$emit("getText")
                if (this.fileList.length > 0 && this.fileList[0].url) {
                this.form.thumb = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                this.form.thumb = this.fileList[0].response.data.url
                } else {
                this.form.thumb = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.is_popup==true?subData.is_popup=1:subData.is_popup=0
                        subData.content_text=subData.content
                        subData.release_time!=""&&subData.release_time!=null?subData.release_time=moment(subData.release_time).format('YYYY-MM-DD HH:mm:ss'): subData.release_time=null
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                setTimeout(() => {
                                    this.onClose()
                                }, 1500)
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.form_box>>>.ant-checkbox + span{max-width: 200px!important;overflow: hidden!important;}
    .sef1{word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;}
</style>
